import { render, staticRenderFns } from "./password-reminder.vue?vue&type=template&id=9d682660&scoped=true&"
import script from "./password-reminder.vue?vue&type=script&lang=js&"
export * from "./password-reminder.vue?vue&type=script&lang=js&"
import style0 from "./password-reminder.vue?vue&type=style&index=0&id=9d682660&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d682660",
  null
  
)

export default component.exports